// extracted by mini-css-extract-plugin
export default {"container":"video_container__3ZB_R","isNative":"video_isNative__X1u4i","inner":"video_inner__35s7i","overlay":"video_overlay__Hqeae"};